import { Location } from '@angular/common';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/services/PermissionsService';
import { environment } from '../../../../environments/environment';
import { BackgroundProcessService } from '../../../../services/backgroundprocess.service';
import { CcService } from '../../../../services/cc.service';
import { CountService } from '../../../../services/count.service';
import { DataService } from '../../../../services/data.service';
import { FileService } from '../../../../services/file.service';
import { RouterService } from '../../../../services/router.service';
import { SecurityService } from '../../../../services/security.service';
import { countstatusResponse } from '../../../Interfaces/icc';
import { ClosedCountsData } from '../../../Interfaces/icount';
import { IuserPermissionsResponse } from '../../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../../error-state-matcher1';


@Component({
  selector: 'app-ccselect',
  templateUrl: './ccselect.component.html',
  styleUrls: ['./ccselect.component.css']
})

export class CcSelectComponent implements OnInit {


  subRef$: Subscription;
  r_ccregs: 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  Columns: string[] = [];
  countColumns: string[] = [];
  Cc: countstatusResponse[] = [];
  closedCounts: ClosedCountsData[] = [];
  ccList = null;
  closedCountsList = null;
  Permissions: IuserPermissionsResponse[] = [];
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuGList =new MatTableDataSource;
  filtermenu = { type: 'G' };
  url = environment.urlAPI;
  progress: number;
  ccId: number = 0;
  ccLabel: string = "Seleccione un centro de costo";
  countingId: number = 0;
  onCount: boolean= false;
  message: string = "";
  messageHistory: string = "";
  downloadCountFile: boolean = false;
  downloadCountFileDisabled: boolean =false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private dataService: DataService,
    private securityService: SecurityService,
    private routeparent: RouterService,
    private ccservice: CcService,
    private countservice: CountService,
    private permissionsService: PermissionsService,
    private _snackBar: MatSnackBar,
    private fileService: FileService,
    private backgroundProcess: BackgroundProcessService,
    private location: Location

  ) {
    this.Columns = ['code', 'name', 'countstatusname', 'b_stc'];
    this.countColumns = ['id', 'typeName', 'startDate', 'userNameStart','endDate','bDownloadFile'];
  }
  selectedvalue: number; selectedview: string;

  ngOnInit() {
    this.message = "Consultando...";
    //permisos
    let url = environment.urlAPI + 'api/user/permission/';
    this.Permissions = [];
    this.MenuG = [];
    this.permissionsService.getPermission("COUNT-SC").subscribe(results => {
      if (results.body.length == 0)
        this.message = "No tiene permisos";
      for (const entry of results.body) {
        this.addPermission({ id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });
      }
      this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
      this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
    },
      (e) => {
        this.message  =  e.error;
        console.log(e);
      });
    //cc
    this.Cc= [];
    this.r_ccregs = 0;
    this.countservice.CountStatus(0).subscribe(results => {
      if (!results.body.isValid)
        this.message = "No hay datos";
      else {
        for (const entry of results.body.resultData) {
          if (this.ccId == 0) {
            this.GetAditionalData(entry.id, entry.code, entry.countinghh_id, entry.oncount);
          }
          this.addCc({
            id: entry.id, name: entry.name, code: entry.code, inventcountstatus: entry.inventcountstatus,
            oncount: entry.oncount, countstatusname: entry.countstatusname, countinghh_id: entry.countinghh_id,
            moduleCode: entry.moduleCode
          });
        }
        this.ccList = new MatTableDataSource<countstatusResponse>(this.Cc);
        this.r_ccregs = this.ccList.data.length;
        this.message = "";
      }
    },
      (e) => {
        this.message= e.error;
        alert(e.error);
        console.log(e);
      });  
  }

  GetClosedCountsHeader(ccId: number) {
    this.messageHistory= "Consultando...";
    this.closedCounts = [];
    this.countservice.GetClosedCountsHeaders(ccId).subscribe(results => {
      if (!results.body.isValid) {
        this.messageHistory = "No hay datos";
      }
      else {
        for (const entry of results.body.resultData) {
          this.addClosedCount({
            id: entry.id, cc_id: entry.cc_id, typeName: entry.typeName,
            startdate: entry.startdate.toString().substring(0, 10), enddate: entry.enddate.toString().substring(0, 10), userNameStart: entry.userNameStart
          });
        }
        this.closedCountsList = new MatTableDataSource<ClosedCountsData>(this.closedCounts);
        this.messageHistory = "";
      }
    },
      (e) => {
        this.messageHistory = e.error;
        alert(e.error);
        console.log(e);
      });

  }
  GetAditionalData(id:number, ccCode:string, countingId:number, onCount:boolean) {
      this.ccId = id;
      this.ccLabel = "CC: " +ccCode;
      this.countingId =countingId;
      this.onCount =onCount;
      this.GetClosedCountsHeader(this.ccId);
  }
  RowClicked(row: any) {
    if (this.ccId != row.id) {
      this.GetAditionalData(row.id, row.code, row.countinghh_id, row.oncount);
    }
  }

  addCc(cc) {
      this.Cc.push(cc);
  }

  addClosedCount(entry){
    this.closedCounts.push(entry)
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    if (permission.type == "G" && permission.code=="X") {

          this.MenuG.push(permission);
    }
    else {
      if (permission.type == "R") {
        switch (permission.code) {
          case "W": {
            this.downloadCountFile = true;
            //this.countColumns.push("bDownloadFile");
            break;
          }
        }
      }

    }
  }

  bDownloadFile(id, name, status, code, countingid, moduleCode) {
    var confirmDownload = confirm("Desea obtener el archivo del conteo?");
    if (confirmDownload) {
      this.downloadCountFileDisabled = true;
      this.countservice.DownClosedCountFile(id).subscribe((response) => {
        if (response.type == HttpEventType.UploadProgress) {
          this.progress = Math.round((100 * response.loaded) / response.total);
          this.message = "Procesando..." + this.progress.toString() + "%";
        }
        else {
          if (response.type == HttpEventType.Response) {
            this.message = "";
            this.downloadFile(response, countingid, id);
            this.downloadCountFileDisabled = false;

          }
          else {
            if (response.type == HttpEventType.ResponseHeader) {
              if (response.status == 404) {
                alert("Error: Archivo no generado");
                this.downloadCountFileDisabled =false;

              }
            }
          }
        }
        (e) => {
          this.message = e.error;
          alert(e.error);
          this.downloadCountFileDisabled = false;
        }
      });
    }
  }

  private downloadFile = (data: HttpResponse<Blob>, vp_CountingId, ccId) => {
    const downloadedFile = new Blob([data.body], { type: data.body.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = "count" + ccId.toString() + ".csv"; // environment.urlAPI + 'api/count/finished/v2/';  //  this.fileUrl;
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
    this.openSB('Archivo ' + a.download + ' bajado');
  }

  b_stc(id, name, status, code, countingid, moduleCode) {
    this.backgroundProcess.GetStatus("counting").subscribe(response => {
      if (response.body.isValid) {
        this.openSB("El conteo se encuentra en proceso de cierre");
        this.b_back();
      }
      else {
        this.ccservice.putValues(id, name, code)
        if (status.trim() == '') {
          this.router.navigate(['/countstart']);
        }
        else {
          if (moduleCode == "ARION") {
            this.countservice.putValues(countingid, moduleCode)
            this.router.navigate(['/locationselect']);
          }
          else {
            this.openSB("El conteo se inicio con otro modulo");
          }
        }
      }
      (e) => {
        this.message = e.error;
        alert(e.error);
      }
    });
  }


  b_gen(link, id) {
        this.router.navigate([link]);
  }

  b_back() {
    let _backRoute = this.routeparent.getBackRoute();
    this.router.navigate([_backRoute], { skipLocationChange: true });
  //  this.router.navigate(['inventory']);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

}
